import { DisplayType, EditableTypes, RequiredType } from './base';

// Component
import { getInfoRenderComponent } from './components/InformationPopoverComponent';
import {
  SUPAGARD_LEATHER_UNIQUE_CODE_REGEX,
  SUPAGARD_UNIQUE_CODE_REGEX,
} from './supagard-constants';

export {
  SUPAGARD_LEATHER_UNIQUE_CODE_REGEX,
  SUPAGARD_UNIQUE_CODE_REGEX,
} from './supagard-constants';

// Constants
export const SUPAGARD_VEHICLE_TYPES = [
  'Car',
  'Caravan/Motorhome',
  'Motorcycle',
  'Commercial/Van',
];

export default {
  HOLDINGS: {
    NEW_REGISTRATION_FLOW: {
      ADDITIONAL_FIELDS: {
        salesperson: {
          type: 'string',
          title: 'Sales Person Name',
          initialValue: '',
          decoration: {
            placeholder: 'Enter the sales person name',
          },
        },
        salesReferenceNo: {
          type: 'string',
          title: 'Sales Reference Number',
          initialValue: '',
          decoration: {
            placeholder: 'Enter the sales reference number',
          },
        },
        make: {
          type: 'auto-complete-suggestion-text',
          title: 'Make',
          initialValue: '',
          validation: {
            required: RequiredType.REQUIRED_FOR_ALL,
          },
          decoration: {
            placeholder: 'Enter make',
          },
          suggestion: [],
          editable: [EditableTypes.EDITABLE_FOR_CONSUMER],
        },
        model: {
          type: 'auto-complete-suggestion-text',
          title: 'Model',
          initialValue: '',
          validation: {
            required: RequiredType.REQUIRED_FOR_ALL,
          },
          decoration: {
            placeholder: 'Enter model',
          },
          suggestion: [],
          editable: [EditableTypes.EDITABLE_FOR_CONSUMER],
        },
        color: {
          type: 'string',
          title: 'Colour',
          initialValue: '',
          validation: {
            required: RequiredType.REQUIRED_FOR_ALL,
          },
          decoration: {
            placeholder: 'Enter colour',
          },
          editable: [EditableTypes.EDITABLE_FOR_CONSUMER],
        },
        interior: {
          type: 'single-select',
          title: 'Interior',
          initialValue: '',
          options: [
            'Mixed',
            'Fabric',
            'Leather - Alcantara',
            'Leather - Genuine',
            'Leather - Synthetic',
          ],
          validation: {
            required: RequiredType.REQUIRED_FOR_ALL,
          },
          decoration: {
            placeholder: 'Select interior',
          },
          colSpan: 2,
        },
        vehicleNo: {
          type: 'string',
          title: 'Vehicle Registration Number',
          initialValue: '',
          validation: {
            required: RequiredType.REQUIRED_FOR_ALL,
          },
          decoration: {
            placeholder: 'Enter vehicle no.',
          },
          editable: [EditableTypes.EDITABLE_FOR_CONSUMER],
        },
        newVehicle: {
          type: 'boolean',
          title: 'New Vehicle',
          initialValue: false,
          colSpan: 2,
        },
        vehicleType: {
          type: 'radio',
          title: 'Vehicle Type',
          options: SUPAGARD_VEHICLE_TYPES,
          validation: {
            required: RequiredType.REQUIRED_FOR_ALL,
          },
          decoration: {
            placeholder: 'Select vehicle type',
          },
          colSpan: 2,
        },
        uniqueCode: {
          type: 'string',
          title: 'Unique Code',
          label: 'Unique Code',
          initialValue: '',
          display: [
            DisplayType.DISPLAY_FOR_TENANT,
            DisplayType.DISPLAY_FOR_PARTNERS,
            DisplayType.DISPLAY_FOR_CONSUMER,
          ],
          validation: {
            required: RequiredType.REQUIRED_FOR_CONSUMER,
            unique: true,
            // Matches (SGW|SWG) followed by a 6-digit code starting with 0, 3, 4, 5, or 6
            regex: SUPAGARD_UNIQUE_CODE_REGEX,
          },
          decoration: {
            placeholder: 'Enter product unique code',
          },
          infoRender: getInfoRenderComponent(
            [
              {
                id: 'uniqueCode',
                imgPath:
                  'https://firebasestorage.googleapis.com/v0/b/eulive-78764.appspot.com/o/img2%2FUnique%20Code%20Pocket.jpg?alt=media&token=6a4648f9-8a26-434d-b560-3e22fbe13891',
              },
              {
                id: 'uniqueCode',
                imgPath:
                  'https://firebasestorage.googleapis.com/v0/b/eulive-78764.appspot.com/o/img2%2FUnique%20Code%20Sample.jpg?alt=media&token=b747c718-d35d-4c83-a313-121ecad97fe9',
              },
            ],
            'top',
            250
          ),
        },
        leatherUniqueCode: {
          type: 'string',
          title: 'Leather Unique Code (If applicable)',
          label: 'Leather Unique Code',
          initialValue: '',
          display: [
            DisplayType.DISPLAY_FOR_TENANT,
            DisplayType.DISPLAY_FOR_PARTNERS,
            DisplayType.DISPLAY_FOR_CONSUMER,
          ],
          validation: {
            unique: true,
            // Regex matches codes from SL000001 to SL200000
            regex: SUPAGARD_LEATHER_UNIQUE_CODE_REGEX,
          },
          decoration: {
            placeholder: 'Enter leather unique code',
          },
          infoRender: getInfoRenderComponent(
            [
              {
                id: 'leatherUniqueCode',
                imgPath:
                  'https://firebasestorage.googleapis.com/v0/b/eulive-78764.appspot.com/o/img2%2FLeather-Card-Front.jpg?alt=media&token=98a4f729-b657-4f47-8830-70c3f49a18ad',
              },
              {
                id: 'leatherUniqueCode',
                imgPath:
                  'https://firebasestorage.googleapis.com/v0/b/eulive-78764.appspot.com/o/img2%2FLeather-Card-Back.jpg?alt=media&token=11ac243e-95ae-48e4-a3dd-a6205b6c2d96',
              },
            ],
            'top',
            250
          ),
        },
        vin: {
          type: 'string',
          title: 'VIN Number',
          initialValue: '',
          decoration: {
            placeholder: 'Enter the vin number',
          },
        },
        additionalInfo: {
          type: 'string',
          title: 'Additional Vehicle Information',
          initialValue: '',
          decoration: {
            placeholder: 'Enter any other suitable information',
          },
        },
      },
    },
  },
};
